import React from 'react';

import './RadioButtonGroup.css';

export type RadioButtonGroupOption<T> = {
  label: string;
  value: T;
};

type RadioButtonGroupProps<T> = {
  options: RadioButtonGroupOption<T>[];
  selectedValue: T | undefined;
  onChangeValue: (val: T) => void;
};

export const RadioButtonGroup = <T,>({
  options,
  selectedValue,
  onChangeValue,
}: RadioButtonGroupProps<T>) => {
  // Aggiungere option come button

  return (
    <div className="radio-button-group--container">
      {options.map((o, i) => {
        const isSelected = o.value === selectedValue;
        return (
          <React.Fragment key={i}>
            <button
              role="button"
              onClick={() => onChangeValue(o.value)}
              className={`radio-button-group--element ${
                isSelected ? 'radio-button-group--selected-element' : ''
              }`}
            >
              {o.label}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};
